import { Directive, HostListener, inject, OnInit } from '@angular/core';
import { DOCUMENT } from "@angular/common";

@Directive({
  selector: '[appFullscreen]',

})
export class FullscreenDirective implements OnInit {
  private document = inject(DOCUMENT);

  public fullScreen: boolean = false;
  public elem: any;

  constructor() { }

  ngOnInit(){
    this.elem = document.documentElement;
  }

  @HostListener('click')
  onClick(){
    this.fullScreen = !this.fullScreen;
    if (this.fullScreen) {
      if (this.elem.requestFullscreen) {
        this.elem.requestFullscreen();
      } else if ((this.elem as any).mozRequestFullScreen) {
        /* Firefox */
        (this.elem as any).mozRequestFullScreen();
      } else if ((this.elem as any).webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        (this.elem as any).webkitRequestFullscreen();
      } else if ((this.elem as any).msRequestFullscreen) {
        /* IE/Edge */
        (this.elem as any).msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if ((this.document as any).mozCancelFullScreen) {
        /* Firefox */
        (this.document as any).mozCancelFullScreen();
      } else if ((this.document as any).webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        (this.document as any).webkitExitFullscreen();
      } else if ((this.document as any).msExitFullscreen) {
        /* IE/Edge */
        (this.document as any).msExitFullscreen();
      }
    }
  }
}
